/* global __BUILD_TIME__ */
// #3451 - the ISO time this scribe-fe bundle was built, injected at build time
// by vite.config.js (`define: { __BUILD_TIME__ }`). The heartbeat sends it so
// score-api can order two builds that share a version (a hand hotfix keeps the
// version; see apps/score-api/src/lib/app-build.js). `typeof` guard: absent in
// unit tests and dev servers, where the heartbeat simply sends null, the same
// as a build from before this existed.
//
// @param {string} [override] - explicit value (tests).
// @returns {string|null}
export function resolveBuildTime(override) {
  if (override !== undefined) return override;
  return typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : null;
}
